<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-card>
      <v-card-text class="pa-5">
        <v-row justify="space-between">
          <v-col cols="12" lg="4">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Поиск..."
              filled
              background-color="transparent"
              hide-details
              name="title"
            >
              <v-btn v-if="search" class="reset-button"
                     slot="append"
                     icon
                     @click="search = null"
                     color="red"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-text-field>
          </v-col>
          <v-col>
            <v-switch
              v-model="only_trashed"
              label="Показать удаленные"
              name="only_trashed"
              value="1"
            ></v-switch>
          </v-col>
          <v-col cols="12" lg="4" class="justify-end align-center d-flex">
            <v-dialog v-model="dialog" persistent max-width="700px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" to="/events/create">
                  Создать событие
                </v-btn>
                <v-btn color="primary" class="ml-2" :href="getExportUrl">
                  Выгрузить
                </v-btn>
              </template>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="auto">
            <v-row align="center">
              <v-col class="pr-0">
                <v-select
                  v-if="statuses"
                  v-model="query.status"
                  :items="statuses"
                  label="Статус"
                  name="status"
                  prepend-icon="mdi-pulse"
                ></v-select>
              </v-col>
              <v-col cols="auto" class="pl-0">
                <v-btn
                  icon
                  @click="query.region_id = null"
                  color="red"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="items"
              :options.sync="options"
              :loading="loading"
              :server-items-length="total"
              :search="search"
              :footer-props="{'items-per-page-options':[5, 10, 15, 20, -1]}"
            >
              <template v-slot:item.id="{ item }">
                <v-chip pill>{{ item.id }}</v-chip>
              </template>
              <template v-slot:item.status="{ item }">
                <v-chip :color="getStatusColor(item.status)" :content="item.human_status" label>{{ item.human_status }}</v-chip>
              </template>
              <template v-slot:item.actions="{ item }">
    <!--            <v-btn-->
    <!--              icon-->
    <!--              v-if="item.preview_url"-->
    <!--              :href="item.preview_url"-->
    <!--              target="_blank"-->
    <!--            >-->
    <!--              <v-icon-->
    <!--                color="primary"-->
    <!--              >-->
    <!--                mdi-eye-->
    <!--              </v-icon>-->
    <!--            </v-btn>-->
                <v-btn
                  :href="editItem(item)"

                  icon
                  small
                >
                  <v-icon color="primary">
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  :href="item.preview_url"
                    target="_blank"
                  icon>
                  <v-icon color="primary" small>
                    mdi-eye
                  </v-icon>
                </v-btn>
                <v-icon
                  class="mr-2"
                  color="primary"
                  @click="copyItem(item)"
                  small
                >
                  mdi-content-copy
                </v-icon>
              </template>
              <template v-slot:item.delete="{ item }">
                <v-icon
                  v-if="item.deleted_at"
                  color="green"
                  @click="restoreItem(item)"
                  small
                >
                  mdi-backup-restore
                </v-icon>
                <v-icon
                  v-else
                  color="red"
                  @click="deleteItem(item)"
                  small
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axiosInstance from '../../../axiosInstance';
import {Event} from "../../../models/event";

export default {
  name: 'Index',
  data: () => ({
    loading: true,
    total: 0,
    options: {
      sortBy: ['id'],
      sortDesc: [true],
      page: 1,
      itemsPerPage: 20
    },
    query: {
      status: null,
    },
    search: '',
    only_trashed: 0,
    headers: [
      {text: 'Id', value: 'id'},
      {text: 'Автор', value: 'creator.name'},
      {text: 'Название', value: 'title'},
      {text: 'Slug', value: 'slug'},
      {text: 'Дата мероприятия', value: 'event_date'},
      {text: 'Статус', value: 'status'},
      {text: 'Дата создания', value: 'created_at'},
      {text: 'Дата обновления', value: 'updated_at'},
      {text: '', value: 'actions'},
      {text: '', value: 'delete'},
    ],
    statuses: [
      {text: 'Все', value: null},
      {text: 'Черновик', value: 0},
      {text: 'Опубликовано', value: 1},
    ],
    items: [],
    regions: [],
    creators: [],
    page: {
      title: "События"
    },
    breadcrumbs: [
      {
        text: "Админ панель",
        disabled: false,
        to: '/'
      },
      {
        text: "Календарь",
        disabled: true,
        to: '/events'
      },
    ],
  }),
  created() {
    this.get();
  },
  computed: {
    filters() {
      const filters = [];

      Object.keys(this.query).map((key) => {
        if (this.query[key] !== null) {
          filters.push({field: key, operator: '=', value: this.query[key]});
        }
      });

      return filters;
    },
    getExportUrl() {
      const payload = {
        title: this.search,
        status: this.query.status,
      };

      return process.env.VUE_APP_API_URL + '/api/module/events/export?' + (new URLSearchParams(payload).toString());
    },
  },
  methods: {
    editItem(item) {
      return this.$router.resolve({name: 'events-edit', params: {id: item.id}}).href
    },
    async deleteItem(item) {
      this.$confirm('Вы уверены?', 'Удаление').then(() => {
        Event.$query().destroy(item.id, 0);
        this.get();
      });
    },
    async restoreItem(item) {
      await Event.$query().restore(item.id);
      await this.get();
    },
    async copyItem(item) {
      await axiosInstance.get(`/module/events/${item.id}/make-copy`);
      await this.get();
    },
    async get() {
      this.loading = true;
      const {sortBy, sortDesc, page, itemsPerPage} = this.options;

      const data = {};
      this.search ? data.search = {value: this.search} : null;
      this.filters ? data.filters = this.filters : null;
      sortBy && sortBy[0] ? data.sort = [{field: sortBy[0], direction: sortDesc[0] ? 'desc' : 'asc'}] : null;

      const onlyTrashed = this.only_trashed ? `&only_trashed=1` : '';

      await axiosInstance.post(`/module/events/search?limit=${itemsPerPage}&page=${page}${onlyTrashed}`, data)
        .then((response) => {
          this.items = response.data.data;
          this.total = response.data.meta.total;
        });

      this.loading = false;
    },
    getStatusColor(status) {
      switch (status) {
        case 0:
          return 'red';
        case 1:
          return 'green';
        default:
          return 'grey';
      }
    },
  },
  watch: {
    search: {
      handler(newSearch, oldSearch) {
        newSearch != oldSearch ? this.options.page = 1 : '';
        this.get();
      }
    },
    only_trashed: {
      handler() {
        this.get();
      }
    },
    options: {
      handler() {
        this.get()
      },
      deep: true,
    },
    query: {
      handler() {
        this.options.page = 1;

        this.get();
      },
      deep: true,
    }
  }
};
</script>
